export default "/048cb1f2b29308e18768c65cfd51e426596a830c/f5c29e86d3a5b6f06334d35443df7aba.svg";